import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW2600Component } from './kymw2600.component';
import { GetWPlaceListService } from './api-services/get-w-place-list-service';
import { UploadWPlaceListService } from './api-services/upload-w-place-list-service';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { FileDownloadService } from '../../../commons/kymw02/file-download-confirm/file-download.service';

/**
 * Ｗ掲載リスト画面 モジュール設定クラス
 *
 * @export KYMW2600Module
 * @class KYMW2600Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW2600Component,
  ],
  providers: [
    GetWPlaceListService,
    UploadWPlaceListService,
    FileDownloadConfirmService,
    FileDownloadService,
  ],
})
export class KYMW2600Module {
}
